import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { toast, ToastContainer } from "react-toastify";
// import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import CheckBox from "../Reacttable/UserManagement/ReactTableFiles/CheckBox";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import TableViewIcon from "@mui/icons-material/TableView";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";

export default function FilterTable() {
  const [data, setData] = useState([
    {
      date: moment(new Date()).format("DD/MM/YYYY"),

      name: "paras",

      senderid: "45",

      message: "33",

      interface: "ff",

      channel: "one",

      creditused: "two",
      // extra: "two",
    },
    {
      date: moment(new Date()).format("DD/MM/YYYY"),

      name: "dhiman",

      senderid: "45",

      message: "33",

      interface: "ff",

      channel: "one",

      creditused: "two",
      // extra: "two",
    },
  ]);
  // console.log("data table------", data);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);

  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    await modelButtonApprove.current.click();
  };

  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  const rejectUserApi = async () => {};
  const approveUserApi = async (cell) => {};

  const approveUser = async (cpId) => {};

  // .............................Delete Post API..................................................//

  async function DeletePost(values) {}

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        Footer: "Date",
        accessor: "date", // accessor is the "key" in the data
      },

      {
        Header: "Name",
        Footer: "Name",
        accessor: "name",
      },
      {
        Header: "SenderId",
        Footer: "SenderId",
        accessor: "senderid", // accessor is the "key" in the data
      },
      {
        Header: "Message",
        Footer: "Message",
        accessor: "message",
      },
      {
        Header: "Interface",
        Footer: "Interface",
        accessor: "interface",
      },
      {
        Header: "Channel",
        Footer: "Channel",
        accessor: "channel",
      },
      {
        Header: "Credit Used",
        Footer: "Credit Used",
        accessor: "creditused",
      },
      {
        Header: "View",
        Footer: "View",
        accessor: "view",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={DeletePost}
            >
              {/* <i className="material-icons opacity-10 size">person</i> */}
              <VisibilityIcon />
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                onClick={() => {
                  // console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    // console.log("reject", cell);
                    rejectUserModal(cell);
                  }}
                >
                  reject User
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    // console.log("approved", cell);
                    approveUserModal(cell);
                  }}
                >
                  Approve User
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  delivered
                </a>
              </li>
            </ul>
          </div>
          // <>
          // <button onClick={()=>console.log("fffgghhgggg",cell.row.original)}>view</button>
          // </>
        ),

        disableFilters: true,
      },
    ],
    []
  );

  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
    // useColumnOrder,
    // useBlockLayout,
    // useSticky,
    // (hooks) => {
    //   hooks.visibleColumns.push((columns) => {
    //     return [
    //       {
    //         id: "selection",
    //         Header: ({ getToggleAllRowsSelectedProps }) => (
    //           <CheckBox {...getToggleAllRowsSelectedProps()} />
    //         ),
    //         Cell: ({ row }) => (
    //           <CheckBox {...row.getToggleRowSelectedProps()} />
    //         ),
    //       },
    //       ...columns,
    //     ];
    //   });
    // }
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  return (
    <div>
      {selectedUserDetail != undefined && (
        <div>
          <button
            ref={modelButtonReject}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Reject User
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <h4>User Information</h4>
                  <h5>User ID:{selectedUserDetail.id}</h5>
                  <h5>User ID:{selectedUserDetail.firstName}</h5>
                  <h5>User ID:{selectedUserDetail.role}</h5>
                  <h5>User ID:{selectedUserDetail.email}</h5>
                  <div>
                    <label>
                      Rejected Reason
                      <input
                        type="text"
                        value={selectedUserDetail.rejectedReason}
                        onChange={(e) => {
                          setSelectedUserDetail({
                            ...selectedUserDetail,
                            rejectedReason: e.target.value,
                          });
                        }}
                      />
                    </label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      rejectUserApi();
                    }}
                  >
                    Reject User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {selectedUserDetailApprove != undefined && (
        <div>
          <button
            ref={modelButtonApprove}
            type="button"
            className="btn btn-primary d-none"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop1"
          >
            Launch static backdrop modal
          </button>

          <div
            className="modal fade"
            id="staticBackdrop1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabindex="-1"
            aria-labelledby="staticBackdrop1Label"
            aria-hidden="true"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdrop1Label">
                    Approve User
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <h4>User Information</h4>
                  <h5>User ID:{selectedUserDetailApprove.id}</h5>
                  <h5>User ID:{selectedUserDetailApprove.firstName}</h5>
                  <h5>User ID:{selectedUserDetailApprove.role}</h5>
                  <h5>User ID:{selectedUserDetailApprove.email}</h5>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      approveUserApi();
                    }}
                  >
                    Approve User
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container-fluid">
        {/* <div class="card mb-3 mt-4"> */}
        <div class="card-body mt-2">
          {/* <ul class="nav nav-tabs pt-5" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#AccountDetails"
                  type="button"
                  role="tab"
                  aria-controls="AccountDetails"
                  aria-selected="true"
                >
                  User
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="SenderMasking-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#SenderMasking"
                  type="button"
                  role="tab"
                  aria-controls="SenderMasking"
                  aria-selected="false"
                >
                  User Group
                </button>
              </li>
            </ul> */}
          <div>
            {/* <div>
                <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All
                Columns
              </div> */}
            <div></div>
          </div>
          {/* <div class="dropdown">
              <button
                class="btn bg-gradient-primary dropdown-toggle m-0"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onChange={(e) => setStatus(e.target.value)}
              >
                Status
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a
                    class="dropdown-item"
                    value="pending"
                    onClick={() => {
                      setStatus("allUser");
                    }}
                  >
                    All Users
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="pending"
                    onClick={() => {
                      setStatus("pending");
                    }}
                  >
                    Pending
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="approved"
                    //   onChange={(e) => setStatus(e.target.value)}
                    onClick={() => {
                      setStatus("approved");
                    }}
                  >
                    Approveds
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    value="rejected"
                    onClick={() => {
                      setStatus("rejected");
                    }}
                  >
                    Rejected
                  </a>
                </li>
              </ul>
            </div> */}
          <div className="d-flex justify-content-between my-3">
            <select
              value={pageSize}
              className="dropdown"
              onChange={(e) => {
                setPageSize(Number(e.target.value));
              }}
            >
              {[10, 25, 50].map((value, i) => {
                return (
                  <option
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                    value={value}
                    key={value}
                  >
                    {" "}
                    Show {value}
                  </option>
                );
              })}
            </select>

            <div>
              {/* {allColumns.map((column) => {
                  return (
                    <div key={column.id}>
                      <label>
                        <input
                          type="checkbox"
                          {...column.getToggleHiddenProps()}
                        />
                        {column.Header}
                      </label>
                    </div>
                  );
                })} */}
            </div>
            <div className="d-flex align-items-center">
              <span className="d-block">Search</span>
              <input
                className="form-control ms-2"
                type="text"
                value={globalSearchValue || ""}
                onChange={(e) => {
                  onChange(e.target.value);
                  setGlobalSearchValue(e.target.value);
                }}
              />
            </div>
          </div>

          <div>
            {selectedFlatRows.length > 0 && (
              <button onClick={deletUser}>Delete Users</button>
            )}

            {/* <button onClick={changeOrder}>Change Order</button> */}
          </div>

          <table
            {...getTableProps()}
            id="example"
            className="table table-striped table-bordered dataTable table-sm"
            style={{ width: "100%" }}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className="text-center width_2"
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? "↑"
                            : "↓"
                          : ""}
                      </span>

                      {/* <div>{column.canFilter ? column.render("Filter") : null}</div> */}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} className="text-center">
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })} */}

              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()} className="text-center">
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
            {/* <tfoot>
            {footerGroups.map((footerGroup) => (
              <tr {...footerGroup.getFooterGroupProps()}>
                {footerGroup.headers.map((column) => (
                  <td className="text-center" {...column.getFooterProps}>
                    {column.render("Footer")}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot> */}
          </table>
          <div className="d-flex justify-content-between">
            <div>
              <span>
                Page:
                <strong>
                  {pageIndex + 1} of {pageOptions.length}
                </strong>
              </span>

              <span>
                | Go to Page :{""}
                <input
                  type="number"
                  defaultValue={pageIndex + 1}
                  onChange={(e) => {
                    const pageNumber = e.target.value
                      ? Number(e.target.value) - 1
                      : 0;
                    gotoPage(pageNumber);
                  }}
                  style={{ width: "50px" }}
                />
              </span>
            </div>

            <div>
              {/* <button
                  onClick={() => {
                    gotoPage(0);
                  }}
                  disabled={!canPreviousPage}
                >
                  {"<<"}
                </button> */}

              <button
                className="btn btn_primary m-0"
                type="button"
                disabled={!canPreviousPage}
                onClick={() => {
                  previousPage();
                }}
              >
                Prev
              </button>

              <button
                className="btn btn_primary m-0"
                type="button"
                disabled={!canNextPage}
                onClick={() => {
                  nextPage();
                }}
              >
                Next
              </button>

              {/* <button
                  onClick={() => {
                    gotoPage(pageCount - 1);
                  }}
                  disabled={!canNextPage}
                >
                  {">>"}
                </button> */}
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      {/* <pre>
        <code>
          {JSON.stringify(
            {
              selectFlatRows: selectedFlatRows.map((row) => row.original),
            },
            null,
            2
          )}
        </code>
      </pre> */}
    </div>
  );
}
